export const validateFilters = ({ filters, requiresAdditionalData, t }) => {
  if (!filters.currency) {
    return t("reports.selectCurrency", "اختر العملة");
  }

  const hasPeriod = filters.period || (filters.periodFrom && filters.periodTo);
  if (!hasPeriod) {
    return t("reports.selectPeriod", "اختر الفترة");
  }

  if (filters.periodFrom && !filters.periodTo) {
    return t("reports.selectPeriodTo", "اختر نهاية الفترة");
  }

  if (requiresAdditionalData && !String(filters.additionalData || "").trim()) {
    return t("reports.enterAdditionalData", "أدخل البيانات الإضافية المطلوبة");
  }

  return null;
};
